(function($) {
	'use strict';

	/**
	 * Extract unique control UIDs for a specific standard
	 * 
	 * This function processes the Combined data structure to extract all
	 * unique control UIDs that belong to a specific standard ID. It filters
	 * through related control items and returns a sorted array of control UIDs.
	 * 
	 * @param {Object} data - The data object containing Combined structure
	 * @param {string} standardID - The standard ID to filter by
	 * @param {string} year - The year to process (defaults to "2025")
	 * @returns {Array} Sorted array of unique control UIDs for the specified standard
	 */
	function extractUniqueControlUIDsForStandard(data, standardID, year = "2025") {
		const uniqueControlUIDs = new Set();
		data.Combined.forEach(item => {
			item.relatedCSItems?.forEach(relatedItem => {
				if (relatedItem.standardid?.S === standardID && relatedItem.controluid?.S) {
					uniqueControlUIDs.add(relatedItem.controluid.S);
				}
			});
		});
		return Array.from(uniqueControlUIDs).sort(); // Sorting control UIDs alphanumerically
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = { extractUniqueControlUIDsForStandard };
	} else if (typeof window !== 'undefined') {
		window.extractUniqueControlUIDsForStandard = extractUniqueControlUIDsForStandard;
	}

})(jQuery);
